import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import SearchInput from "pages/Clients/components/SearchInput/SearchInput";
import DataTableRFMClients from '../../../../components/TableElement/DataTableRFMClients/DataTableClients';
import { computePercent } from '../../../../helpers';
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import ButtonOutlined from "../../../../components/FormElements/ButtonOutlined";
import closeModalImage from "../../../../components/PayModal/assets/CloseModalIcon.svg";
import branchApi from "../../../../store/branchStore/branchApi";
import { store } from 'react-notifications-component';

import styles from './rmfClients.module.scss';

import phoneImg from './assets/images/phone.png';
import { useTranslation } from "react-i18next";
import businessReportApi from "../../../../store/analyticsStores/businessReportStore/businessReportApi";

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 0,
    borderRadius: 24,
  }
};

export default function RFMClients() {
  const rfm = useSelector(s => s.RFMReducer);
  const { info } = useSelector(s => s.branchReducer);
  const history = useHistory();
  const { params } = useRouteMatch();
  const { t } = useTranslation()
  const clientType = params.clientType.toUpperCase();
  const [query, setQuery] = useState('');
  const [RFMStatus, setRFMStatus] = useState(null);

  const [pushMessage, setPushMessage] = useState('');
  const [bonus, setBonus] = useState(0);

  const [downloading, setDownloading] = useState(false);

  const [sendModal, setSendModal] = useState(false);
  const [bonusModal, setBonusModal] = useState(false);
  const [bonusModalStep, setBonusModalStep] = useState(1);
  const [pending, setPending] = useState(false);
  const [bonusResult, setBonusResult] = useState(null);
  const [failedPage, setFailedPage] = useState(1);
  const FAILED_PER_PAGE = 10;

  const [filteredClients, setFilteredClients] = useState([]);

  if (!rfm[clientType].length) {
    history.push('/analytics/rfm');
    return null
  }

  useEffect(() => {
    if (!RFMStatus && info && info.configuration && info.configuration.rfm_analysis) {
      setRFMStatus({
        rOne: info.configuration.rfm_analysis.recency.one,
        rTwo: info.configuration.rfm_analysis.recency.two,

        fOne: info.configuration.rfm_analysis.frequency.one,
        fTwo: info.configuration.rfm_analysis.frequency.two,

        mOne: info.configuration.rfm_analysis.monetary.one,
        mTwo: info.configuration.rfm_analysis.monetary.two,
      });
    }
  }, [info]);

  useEffect(() => {
    let clients = [];
    if (query.length) {
      clients = rfm[clientType].filter(c => c.phone.includes(query));

      if (!clients.length) clients = rfm[clientType].filter(c => {
        return `${c.first_name} ${c.last_name}`.toLowerCase().includes(query.toLowerCase())
      });

      setFilteredClients(clients);
    } else {
      setFilteredClients(rfm[clientType]);
    }
  }, [query]);

  const chooseClientAction = (id) => {
    history.replace(`/clients/client/${id}?rfm=${clientType}`);
  }

  const onSendPushToCustomers = () => {
    if (!info || !pushMessage || !rfm[clientType].length) return

    setPending(true);
    const user_ids = rfm[clientType].map((i) => i.id);
    branchApi.sendPushToCustomers(info.id, {user_ids, message: pushMessage, message_channel: 'push'})
        .then((res) => {
          store.addNotification({
            title: t('success'),
            message: t('successMessageSent'),
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
          setPushMessage('');
        })
        .finally(() => {
          setPending(false);
          setSendModal(false);
        });
  }

  const onSendWhatsappToCustomers = () => {
    if (!info || !rfm[clientType].length) return
    history.push(`/rfm/analytics/${clientType}/send-notification`)

    // setPending(true);
    // const user_ids = rfm[clientType].map((i) => i.id);
    // branchApi.sendPushToCustomers(info.id, {user_ids, message: pushMessage, message_channel: 'whatsapp'})
    //   .then((res) => {
    //     store.addNotification({
    //       title: t('success'),
    //       message: t('successMessageSent'),
    //       type: "success",
    //       insert: "top",
    //       container: "top-right",
    //       animationIn: ["animate__animated", "animate__fadeIn"],
    //       animationOut: ["animate__animated", "animate__fadeOut"],
    //       dismiss: {
    //         duration: 5000,
    //         onScreen: true
    //       }
    //     });
    //     setPushMessage('');
    //     history.push(`/rfm/analytics/${clientType}/send-notification`)
    //   })
    //   .finally(() => {
    //     setPending(false);
    //     setSendModal(false);
    //   });
  }

  const onChangePushMessage = (e) => {
    if (e.target.value.length < 150) {
      setPushMessage(e.target.value);
    }
  }

  const onChangePrice = (e) => {
    if (isFinite(+e.currentTarget.value)) {
      // if (!info || Number(info.balance).toFixed() < +e.currentTarget.value) return
      if (!info) return
      setBonus(+e.currentTarget.value);
    }
  }

  const onSendBonusesToUsers = () => {
    if (!info || !bonus || !rfm[clientType].length) return

    setPending(true);
    const user_ids = rfm[clientType].map((i) => i.id);
    branchApi.sendBonusesToUsers(info.id, {user_ids, group_id: info.group_id, amount: bonus})
        .then((res) => {
          const data = res?.data || res;
          const failedPhones = data?.failed_phones || [];
          const successCount = data?.success_count ?? user_ids.length;

          if (failedPhones.length > 0) {
            setBonusResult({ successCount, failedPhones, total: data?.total ?? user_ids.length });
            setFailedPage(1);
            setBonusModalStep(3);
          } else {
            store.addNotification({
              title: t('successMessageSent'),
              message: t('NSClients.successBonus'),
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: { duration: 5000, onScreen: true }
            });
            setBonusModal(false);
            setBonusModalStep(1);
            setBonus(0);
          }
        })
        .finally(() => {
          setPending(false);
        });
  }

  const closeBonusModal = () => {
    setBonusModal(false);
    setBonusModalStep(1);
    setBonus(0);
    setBonusResult(null);
  }

  const exportExcel = () => {
    setDownloading(true);
    businessReportApi.getStatisticsRfmAnalysisExcel(info.id, clientType)
      .catch((e) => {
        console.error('RFM export error:', e);
        alert(e.message || t("exportError"));
      })
      .finally(() => setDownloading(false));
  }

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <SearchInput
          changePhoneAction={(v) => setQuery(v)}
          phone={query}
        />

        <div style={{display: 'flex', width: '495px'}}>
          <ButtonOutlined variant="green" color="black" onClick={() => setBonusModal(true)}>
            {t('NSTransactions.bonus')}
          </ButtonOutlined>
          <div style={{width: '30px'}}></div>
          <ButtonFilled onClick={() => setSendModal(true)}>
            {t('NSStatistics.notification')}
          </ButtonFilled>
        </div>
      </div>

      <div style={{display: "flex", gap: 10, justifyContent: "flex-end", marginTop: "20px"}}>
        <ButtonFilled
          className={styles.btn}
          onClick={onSendWhatsappToCustomers}
          loading={pending}
        >
          {t('send')} Whatsapp
        </ButtonFilled>
        <ButtonFilled
          onClick={exportExcel}
          loading={downloading}
        >
          {t("export")}
        </ButtonFilled>
      </div>

      <div className={styles.info}>
        <div className={styles.infoTop}>
          <h2>
            {t(`NSAnalysis.${rfm[clientType][0].cluster.Type}`)}
          </h2>
          <b>{rfm[clientType].length}</b>
          <span>({computePercent(rfm[clientType].length, rfm.ALL_CUSTOMERS.length)}%)</span>
        </div>
        <table className={styles.infoTable}>
          <thead>
          <tr>
            <th><b>Recency</b>
              {t('NSRfm.last')}
            </th>
            <th><b>Frequency</b>
              {t('NSRfm.transactions')}
            </th>
            <th><b>Monetery</b>
              {t('NSRfm.amount')}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{t('NSStatistics.recent2')} &lt; <b>{RFMStatus && RFMStatus.rOne}</b></td>
            <td>{t('NSRfm.often2')}  &gt; <b>{RFMStatus && RFMStatus.fOne}</b></td>
            <td>{t('NSStatistics.high2')} &gt; <b>{RFMStatus && RFMStatus.mOne}</b></td>
          </tr>
          <tr>
            <td>
              <div className={styles.flex}>
                <div>({t('relatively')} <br/> {t('NSStatistics.recent3')})</div>
                <b>{t('from')} {RFMStatus && RFMStatus.rOne} <br/> {t('till')} {RFMStatus && RFMStatus.rTwo}</b>
              </div>
            </td>
            <td>
              <div className={styles.flex}>
                <div>{t('NSStatistics.infrequently2')}</div>
                <b>{t('from')} {RFMStatus && RFMStatus.fTwo} <br/> {t('till')} {RFMStatus && RFMStatus.fOne}</b>
              </div>
            </td>
            <td>
              <div className={styles.flex}>
                <div>{t('NSStatistics.average2')}</div>
                <b>{t('from')} {RFMStatus && RFMStatus.mTwo} <br/> {t('till')} {RFMStatus && RFMStatus.mOne}</b>
              </div>
            </td>
          </tr>
          <tr>
            <td>{t('NSStatistics.long2')} &gt; <b>{RFMStatus && RFMStatus.rTwo}</b></td>
            <td>{t('NSStatistics.rarely2')} &lt; <b>{RFMStatus && RFMStatus.fTwo}</b></td>
            <td>{t('NSStatistics.low2')} &lt; <b>{RFMStatus && RFMStatus.mTwo}</b></td>
          </tr>
          </tbody>
        </table>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={bonusModal}
        style={modalStyles}
        onRequestClose={closeBonusModal}
      >
        <div className={styles.modal}>
          <div className={styles.closeModal} onClick={closeBonusModal}>
            <img src={closeModalImage}/>
          </div>
          <div className={styles.modalContainer}>
            {
              bonusModalStep === 1 ? (
                <>
                  <div className={styles.header}>
                    <p>{t('NSPayment.assessment')}</p>
                  </div>
                  <div className={styles.bonuses}>
                    <div className={styles.bonusesHeader}>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="9" cy="9" r="9" fill="#E7E7E6"/>
                        <rect x="8" y="6" width="2" height="8" rx="1" fill="#A7A9AF"/>
                        <circle cx="9" cy="4" r="1" fill="#A7A9AF"/>
                      </svg>
                      <p>
                        {t('NSClients.bonus')}
                      </p>
                    </div>
                    <p className={styles.subTitle}>
                      {t('NSClients.bonusCount')}:
                    </p>
                    <input
                      value={bonus}
                      className={styles.inputBonus}
                      onChange={onChangePrice}/>

                    <p className={styles.subTitle}>
                      {t('NSGeneral.clients')}:
                    </p>
                    <div className={styles.bonusInput}>{rfm[clientType].length}</div>
                    <div style={{height: '20px'}}/>
                    <p className={styles.subTitle}>
                      {t('NSClients.sum')}:
                    </p>
                    <div className={`${styles.bonusInput} ${styles.green}`}>{bonus * rfm[clientType].length}</div>

                    <ButtonFilled
                      className={styles.btn}
                      disabled={!bonus}
                      onClick={() => {
                        setBonusModalStep(2);
                      }}
                    >
                      {t('proceed')}
                    </ButtonFilled>
                  </div>
                </>
              ) : bonusModalStep === 2 ? (
                <>
                  <div className={styles.header}>
                    <div style={{cursor: 'pointer'}} onClick={() => setBonusModalStep(1)}>
                      <svg style={{marginRight: 'auto'}} width="23" height="23" viewBox="0 0 23 23" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <rect width="2.70393" height="15.6376" rx="1.35196"
                              transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 13.0293 2.64099)"
                              fill="#AFAFAB"/>
                        <rect x="12.9746" y="21.1027" width="2.62964" height="15.6376" rx="1.31482"
                              transform="rotate(135 12.9746 21.1027)" fill="#AFAFAB"/>
                      </svg>
                    </div>
                  </div>
                  <div className={styles.bonusesResult}>
                    <div><span>{t('NSClients.giveBonus')}:</span> <span>{bonus}</span></div>
                    <div><span>{t('NSClients.clients')}:</span> <span>{rfm[clientType].length}</span></div>

                    <div className={styles.bonusesResultItem}><b>{t('NSClients.toSum')}:</b>
                      <span>{bonus * rfm[clientType].length}</span></div>

                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'flex-end',
                      margin: 'auto auto 0',
                      height: '70%'
                    }}>
                      <ButtonFilled
                        className={styles.btn}
                        loading={pending}
                        onClick={onSendBonusesToUsers}
                      >{t('NSClients.submitPayment')}</ButtonFilled>
                    </div>
                  </div>
                </>
              ) : bonusModalStep === 3 && bonusResult ? (
                <>
                  <div className={styles.header}>
                    <p>{t('NSClients.bonusResult', 'Результат начисления')}</p>
                  </div>
                  <div className={styles.bonusResultContainer}>
                    <div className={styles.bonusResultWarning}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 0 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#D32F2F"/>
                      </svg>
                      <p>
                        <b>{t('NSClients.bonusWarningTitle', 'Не начисляйте бонусы повторно!')}</b>
                        <br/>
                        {t('NSClients.bonusWarningText', 'Остальным {count} клиентам бонусы уже начислены. Повторная отправка приведёт к двойному начислению.').replace('{count}', bonusResult.successCount)}
                      </p>
                    </div>

                    <div className={styles.bonusResultStats}>
                      <div className={styles.bonusResultStatSuccess}>
                        {t('NSClients.bonusSuccessCount', 'Успешно начислено')}: <b>{bonusResult.successCount}</b>
                      </div>
                      <div className={styles.bonusResultStatFail}>
                        {t('NSClients.bonusFailedCount', 'Не удалось начислить')}: <b>{bonusResult.failedPhones.length}</b>
                      </div>
                    </div>

                    <div className={styles.bonusFailedList}>
                      <p className={styles.subTitle}>
                        {t('NSClients.bonusFailedPhones', 'Телефоны с ошибкой')}:
                      </p>
                      <div className={styles.bonusFailedPhones}>
                        {bonusResult.failedPhones
                          .slice((failedPage - 1) * FAILED_PER_PAGE, failedPage * FAILED_PER_PAGE)
                          .map((phone, i) => (
                            <div key={i} className={styles.bonusFailedPhone}>{phone}</div>
                          ))
                        }
                      </div>
                      {bonusResult.failedPhones.length > FAILED_PER_PAGE && (
                        <div className={styles.bonusPagination}>
                          <button
                            disabled={failedPage <= 1}
                            onClick={() => setFailedPage(p => p - 1)}
                          >&laquo;</button>
                          <span>{failedPage} / {Math.ceil(bonusResult.failedPhones.length / FAILED_PER_PAGE)}</span>
                          <button
                            disabled={failedPage >= Math.ceil(bonusResult.failedPhones.length / FAILED_PER_PAGE)}
                            onClick={() => setFailedPage(p => p + 1)}
                          >&raquo;</button>
                        </div>
                      )}
                    </div>

                    <ButtonFilled
                      className={styles.btn}
                      onClick={closeBonusModal}
                      style={{margin: '20px auto 0'}}
                    >
                      {t('close', 'Закрыть')}
                    </ButtonFilled>
                  </div>
                </>
              ) : null
            }
          </div>
        </div>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={sendModal}
        style={modalStyles}
        onRequestClose={() => setSendModal(false)}
      >
        <div className={styles.modal}>
          <div className={styles.closeModal} onClick={() => setSendModal(false)}>
            <img src={closeModalImage}/>
          </div>
          <div className={styles.modalContainer}>
            <div className={styles.header}>
              <p>
                {t('NSClients.not')}
              </p>
            </div>

            <div>
              <p className={styles.p}>
                {t('NSClients.textNot')}
              </p>
              <textarea
                placeholder={t('NSMailing.text') || ''}
                className={styles.textArea}
                value={pushMessage}
                onChange={onChangePushMessage}
                required
              />
              <div className={styles.span} style={{color: `${pushMessage.length >= 149 ? 'tomato' : '#000000'}`}}>
                {t('maxSym', { sym: 150 })}
              </div>

              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '16px'}}>
                <img width="230" src={phoneImg} style={{marginBottom: '16px'}}/>
                <div style={{display: 'flex', gap: 12, alignItems: 'center', marginTop: '16px'}}>
                  <ButtonFilled
                    className={styles.btn}
                    onClick={onSendPushToCustomers}
                    loading={pending}
                  >
                    {t('send')}
                  </ButtonFilled>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <DataTableRFMClients
        customers={filteredClients}
        count={2}
        page={1}
        change1PageAction={() => {
        }}
        status={''}
        chooseClientAction={chooseClientAction}
      />
    </div>
  )
}
